import { hasValidToken } from './getToken';

export const getHomeLink = () => (hasValidToken() ? '/book/expedition' : '/');
